/*
 * Copyright © 2017 TEKTELIC Communications Inc.
 */

import './entity.scss';

/* eslint-disable import/no-unresolved, import/default */

import entityTemplate from './entity.tpl.html';

/* eslint-enable import/no-unresolved, import/default */

/*@ngInject*/
export default function Entity() {
    return {
        restrict: "E",
        scope: true,
        bindToController: {
            entityTableConfiguration: '=',
            actionDescriptors: '=',
            entity: '=',
            isEdit: '=',
            isReadOnly: '=',
            theForm: '=',
            onDelete: '&',
            selectedTab: '=?selectedTab'
        },
        controller: EntityController,
        controllerAs: 'vm',
        templateUrl: entityTemplate
    };
}

/*@ngInject*/
function EntityController($scope, types) {

    var vm = this;

    vm.$onInit = function () {
        vm.types = types;
        vm.entityType = vm.entityTableConfiguration.entityType;
    };
}


// WEBPACK FOOTER //
// ./src/app/table/entity.directive.js